import React from "react";
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

// Icon
import { FaRegBell } from "react-icons/fa";
import { MdOutlineMailOutline } from "react-icons/md";

const styleCard ={
    borderRadius: '1rem'
}

const styleLi = {
    marginTop : '3vh'
}

const EmailedToday = (props) => {

    return (<>
        <Card style={styleCard}>
            <CardBody>
                <CardTitle>Email sent today</CardTitle>
                <div className="feed-widget">
                    <ul className="list-style-none feed-body m-0 pb-3">
                        <li style={styleLi}>
                            <MdOutlineMailOutline size={18} color="blue" /> &nbsp; 1245 Email sent today
                        </li>
                        <li>
                        <FaRegBell size={18} color="blue" />  &nbsp; 7535 Email sent this week
                        </li>
                        {/* <li className="feed-item">
                            <div className="feed-icon bg-warning"><i className="ti-shopping-cart"></i></div> 7834 Email sent last week
                        </li>
                        <li className="feed-item">
                            <div className="feed-icon bg-danger"><i className="ti-user"></i></div> 27390 Email sent this month
                        </li> */}
                    </ul>
                </div>
            </CardBody>
        </Card>
    </>);
}

export default EmailedToday;